import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <section className="w-full bg-cream" data-id="element-270" data-mp="27manniz0xanl">
      <div className="mx-auto w-full max-w-3xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-271" data-mp="27n3vyodms87u">
        <h2 className="text-center font-display text-[30px] font-black leading-[1.1] tracking-[-0.02em] text-plum-deep sm:text-4xl" data-id="element-272" data-mp="22vc1w3v9nkcy">
          Ti suona familiare?
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-273" data-mp="2cldoer7z0upr">
          {painPoints.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white p-4 ring-1 ring-ink/10 sm:p-5" data-id="element-274" data-mp="2cnrjv16kc8xu">
              <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-plum" aria-hidden="true" data-id="element-275" data-mp="2mkmeh8zptp6u" />
              <span className="text-[15px] leading-snug text-ink/75 sm:text-base" data-id="element-276" data-mp="w86rc64yrafd">{item}</span>
            </li>)}
        </ul>

        <div className="mt-9 rounded-3xl bg-plum-soft p-6 ring-1 ring-plum/20 sm:p-8" data-id="element-277" data-mp="s7mwxabrykwx">
          <h3 className="font-display text-[22px] font-black leading-tight text-plum-deep sm:text-[26px]" data-id="element-278" data-mp="1n9mv7vmjqhod">
            Se hai risposto “sì” anche solo a una di queste situazioni…
          </h3>
          <p className="mt-4 text-[15.5px] leading-relaxed text-ink/75 sm:text-base" data-id="element-279" data-mp="1x4eud3vs1cl9">
            Il Progetto Clinico della Menopausa™ è stato creato specificamente per medici come te.
          </p>
          <p className="mt-4 text-[15.5px] leading-relaxed text-ink/75 sm:text-base" data-id="element-280" data-mp="26v9cpx5wjs1f">
            Perché la differenza tra incertezza e sicurezza non è avere più informazioni.
          </p>
          <p className="mt-2 text-[17px] font-extrabold text-plum sm:text-lg" data-id="element-281" data-mp="2fxscu9iazqjz">
            È avere il giusto sistema clinico.
          </p>
        </div>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-282" data-mp="lipssrc0x0og">
          <CTAButton label="Sì — voglio il giusto sistema clinico" sub="19 € una sola volta • Garanzia soddisfatti o rimborsati di 7 giorni" variant="teal" data-id="element-283" data-mp="lk0wys9dsag3" />
        </div>
      </div>
    </section>;
}